import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const UserDoublePlus = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M14.778 20.278h3.778a.945.945 0 0 0 .944-.945v-.944a2.833 2.833 0 0 0-2.833-2.833h-1.89m-2.111-3.778a2.833 2.833 0 1 0 0-3.778M20 2.5v4m2-2h-4M2.5 19.333v-.944a2.834 2.834 0 0 1 2.833-2.833h3.778a2.834 2.834 0 0 1 2.833 2.833v.944a.945.945 0 0 1-.944.945H3.444a.944.944 0 0 1-.944-.945Zm7.556-9.444a2.834 2.834 0 1 1-5.668 0 2.834 2.834 0 0 1 5.668 0Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(UserDoublePlus) as SvgIcon;
export { ForwardRef as ReactComponent };
